/* eslint-disable no-template-curly-in-string */
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_APROVADO,
  CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_REJEITADO,
} from '../../library/ContratoEntePublicoAcaoAvalia';
import {
  downloadContrato,
  downloadDocumentoById,
} from '../../store/modules/ContratosActions';
import { getContentTypeByUrl } from '../../utils/FileUtils';
import { getElementID, getParsedNewLines } from '../../utils/HTMLUtils';
import { Col } from '../Col';
import { CustomButton } from '../CustomButton';
import CustomDownloadButton from '../CustomDownloadButton/CustomDownloadButton';
import CloudDownloadIcon from '../Icons/CloudDownloadIcon';
import { Row } from '../Row';
import styles from './HistoricoItem.scss';

const rootClassName = styles.rootClassName;
const rootElementId = 'historico-item';

class HistoricoItem extends Component {
  getNome = () => {
    let nome = this.props.languageValues.stepsHistoryFor
      .split('${1}')
      .join(this.props.item.nome);
    return nome;
  };

  downloadIsEnabled = () => {
    const { caminho, extencaoArquivo } = this.props.item;
    return typeof caminho === 'string' && caminho.length > 0 &&
      typeof extencaoArquivo === 'string' && extencaoArquivo.length > 0;
  };

  downloadPlanoIsEnabled = () => {
    return this.props.item.idPlanoTrabalho > 0;
  };

  getDownloadElement = () => {
    if (this.downloadIsEnabled()) {
      return (
        <div className={rootClassName + '-download-container'}>
          <span className={rootClassName + '-download-description'}>
            {
              this.props.languageValues
                .cadastroContratoHistoricoAnaliseOperacionalFileLabel
            }
          </span>
          <CustomDownloadButton
            id={getElementID(rootElementId, this.props.index)}
            downloadAction={this.props.downloadContrato}
            downloadActionData={{
              fileName: this.props.item.caminho,
              contentType: getContentTypeByUrl(
                '.' + this.props.item.extencaoArquivo
              ),
            }}
            buttonComponent={CustomButton}
            buttonComponentProps={{
              className: rootClassName + '-download-button',
              theme: 'pufvYellow',
              icon: <CloudDownloadIcon />,
            }}
            fileName={
              this.props.utils.getContratoRevisaoFileName(
                this.props.item.datAlteracao,
                'YYYY-MM-DD'
              ) +
              '.' +
              this.props.item.extencaoArquivo
            }
          />
        </div>
      );
    }
    return null;
  };

  toDownloadPlano = (
    params,
    callbackProgress,
    callbackSuccess,
    callbackError
  ) => {
    const onProgress = (event) => {
      callbackProgress(event.loaded / event.total);
    };
    this.props.downloadDocumentoById(
      params.id,
      params.contentType,
      onProgress,
      callbackSuccess,
      callbackError
    );
  };

  getDownloadPlanoTrabalhoElement = () => {
    if (this.downloadPlanoIsEnabled()) {
      return (
        <div className={rootClassName + '-download-container'}>
          <span className={rootClassName + '-download-description'}>
            {
              this.props.languageValues
                .cadastroContratoHistoricoAnaliseOperacionalFilePlanoTrabalhoLabel
            }
          </span>
          <CustomDownloadButton
            id={getElementID(
              rootElementId,
              'plano-trabalho-' + this.props.index
            )}
            downloadAction={this.toDownloadPlano}
            downloadActionData={{
              id: this.props.item.idPlanoTrabalho,
              contentType: this.props.item.extencaoArquivoPlanoTrabalho,
            }}
            buttonComponent={CustomButton}
            buttonComponentProps={{
              className: rootClassName + '-download-button',
              theme: 'pufvYellow',
              icon: <CloudDownloadIcon />,
            }}
            fileName={
              this.props.utils.getContratoPlanoTrabalhoFileName() +
              '.' +
              this.props.item.extencaoArquivoPlanoTrabalho
            }
          />
        </div>
      );
    }
    return null;
  };

  getAvaliaTag = () => {
    if (this.props.item.isAnaliseOperacional) {
      const acaoAvaliaValue = this.props.item.acaoAvaliaValue;
      let sulfixClassName = '-operacional';
      let tagLabel = this.props.languageValues.cadastroContratoOperacional;
      if (typeof acaoAvaliaValue === 'number' && acaoAvaliaValue > -1) {
        switch (acaoAvaliaValue) {
          case CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_REJEITADO:
            sulfixClassName = '-rejeitado';
            tagLabel =
              this.props.languageValues
                .historicoAnaliseOperacionaldocumentoRejeitado;
            break;
          case CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_APROVADO:
            sulfixClassName = '-aprovado';
            tagLabel =
              this.props.languageValues
                .historicoAnaliseOperacionaldocumentoAprovado;
            break;
          default:
            break;
        }
      }
      return <div className={rootClassName + sulfixClassName}>{tagLabel}</div>;
    }
    return null;
  };

  render() {
    return (
      <Row className={rootClassName}>
        <Col cols={[12, 12, 12, 12, 12]}>
          <div>
            {this.getAvaliaTag()}
            <span className={rootClassName + '-date'}>
              {moment(
                this.props.item.dataCriacao,
                'YYYY MM DD HH:mm:ss'
              ).format('DD/MM/YYYY - HH:mm:ss')}
            </span>
            <br />
            <p className={rootClassName + '-nome'}>{this.getNome()}</p>
            {this.props.item.justificativa &&
              this.props.item.justificativa.length > 0 ? (
              <p className={rootClassName + '-justificativa'}>
                {getParsedNewLines(this.props.item.justificativa.trim())}
              </p>
            ) : (
              ''
            )}
            {this.getDownloadElement()}
            {this.getDownloadPlanoTrabalhoElement()}
          </div>
        </Col>
      </Row>
    );
  }
}

HistoricoItem.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      downloadContrato,
      downloadDocumentoById,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HistoricoItem);
